import 'bootstrap/dist/css/bootstrap.min.css'
import "./App.css"
import { useEffect, useState } from 'react'
import { Helmet } from "react-helmet"
import { getMovieList, searchMovie } from "./api"

const App = () => {
  const [popularMovie, setPopularMovie] = useState([])

  useEffect(() => {
    getMovieList().then((result) => {
      setPopularMovie(result)
    })
  }, [])

  const PopularMovieList = () => {
    return popularMovie.map((movie, i) => {
      return (
        <div className="col" key={i}>
          <div className="card shadow-sm" id='cardH'>
            <img className="card-img-top" src={`${process.env.REACT_APP_BASEIMGURL}${movie.poster_path}`} alt="" />

            <div className="card-body">
              <h5 className="card-title">{movie.title}</h5>
              <p className="card-text">{movie.overview}</p>
              <div className="d-flex justify-content-between align-items-center">
                <div className="btn-group" id='rating' height='100%'>
                  <div className="btn btn-sm btn-outline-secondary">Ratting</div>
                  <div className="btn btn-sm btn-outline-secondary">{movie.vote_average}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    })
  }

  const search = async (q) => {
    if (q.length > 3) {
      const query = await searchMovie(q)
      setPopularMovie(query.results)
    }

  }
  return (
    <div className="app">
      <Helmet>
        <meta charSet="utf-8" />
        <title>KIKU INDEX MOVIE</title>
      </Helmet>
      <div className="container">
        <header className="d-flex flex-wrap justify-content-center py-3 mb-4 border-bottom">
          <a href="/" className="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-dark text-decoration-none">
            <span className="fs-4"><b>KIKU INDEX MOVIE</b></span>
          </a>

          <ul className="nav nav-pills">
            <li className="nav-item"><a href="a" className="nav-link active" aria-current="page">Home</a></li>
            <li className="nav-item"><a href="#populerMovie" className="nav-link">Populer Movie</a></li>
            <li className="nav-item"><a href="#a" className="nav-link">FAQs</a></li>
            <li className="nav-item"><a href="#a" className="nav-link">About</a></li>
          </ul>
        </header>
      </div>
      <div className="container p-5">
        <div className="row">
          <div className="col">
            <input type="email" className="form-control text-center" id="colFormLabel" placeholder="TITLE..." onChange={({ target }) => search(target.value)} />
          </div>
          <div className="row pt-2">
            <div className="col" align="center">
              <input type="submit" value="Search!" className='btn btn-outline-primary btn-lg' />
            </div>
          </div>
        </div>
      </div>
      <div className="container" id='populerMovie'>

        <div className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
          {/* start card */}
          <PopularMovieList />
          {/* end card */}
        </div>
        <div className="container">
          <footer className="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
            <div className="col-md-4 d-flex align-items-center">
              <a href="/" className="mb-3 me-2 mb-md-0 text-muted text-decoration-none lh-1">
                <svg className="bi" width="30" height="24"></svg>
              </a>
              <span className="mb-3 mb-md-0 text-muted">© {new Date().getFullYear()} Mifatkhuddin Falaki</span>
            </div>

            <ul className="nav col-md-4 justify-content-end list-unstyled d-flex">
              <li className="ms-3"><a className="text-muted" href="a"><svg className="bi" width="24" height="24"></svg>GitHub</a></li>
              <li className="ms-3"><a className="text-muted" href="a"><svg className="bi" width="24" height="24"></svg>Blog</a></li>
              <li className="ms-3"><a className="text-muted" href="a"><svg className="bi" width="24" height="24"></svg>Linkedin</a></li>
            </ul>
          </footer>
        </div>
      </div>
    </div>
  );
}

export default App;
